import React, { useEffect, useState, memo } from 'react';
import { TbBulb } from 'react-icons/tb';
import { Capitalize } from './../../functions/commonFunctions';
import {
  getDescriptiveSummary,
  getAlertSummary,
  getNarrativefromDb,
  getNarrativeBankfromDb
} from '../../services/summaryService';
import parse from 'html-react-parser';
import { BsChatSquareDots } from 'react-icons/bs';
import { HiOutlineArrowNarrowRight } from 'react-icons/hi';
import { Triangle } from 'react-loader-spinner';
import { Modal } from 'react-bootstrap';

const BusinessNarratives = (props) => {
  const [dimsummary, setDimensionSummary] = useState([]);
  const [activesummary, setActiveSummary] = useState({
    level: '',
    summary: ''
  });
  const [showmodal, setShowModal] = useState(false);
  const [loader, setLoader] = useState(true);
  const [loadermessage, setLoaderMessage] = useState('');

  useEffect(() => {
    async function getData() {
      try {
        setLoader(true);
        // enable loader messages
        const messages = [
          'Fetching Persona details',
          'Identifying preferred metrics',
          'Sending preference to Gen AI',
          'Fetching key insights',
          'Summarizing insights',
          'Finalising results',
          'Please wait few more seconds'
        ];
        let count = 0;
        setLoaderMessage(messages[count]);
        const interval = setInterval(function message() {
          count += 1;
          setLoaderMessage(messages[count]);
          if (count === messages.length - 1) clearInterval(interval);
        }, 3000);
        // Fetch descriptive summary
        const { data: descriptive_summary } = await getNarrativeBankfromDb(
          props.user.user_uuid || ''
        );
        setDimensionSummary(descriptive_summary);
        setLoader(false);
        // Fetch alert summary
        // const { data: alert_summary } = await getAlertSummary(props.user.user_uuid || '');
        // if (alert_summary.length > 0) {
        //   descriptive_summary.forEach((x, i) => {
        //     alert_summary.forEach((y, j) => {
        //       if (x.level === y.level) {
        //         if (j === 0) descriptive_summary[i].summary += '<br/><br/>' + y.summary;
        //         else descriptive_summary[i].summary += y.summary;
        //       }
        //     });
        //   });
        // }
        // setDimensionSummary(descriptive_summary);
      } catch (err) {
        setLoader(false);
        console.log(err);
      }
    }
    getData();
  }, [props.user.user_uuid]);

  const narrativeModal = () => {
    return (
      <Modal
        show={showmodal}
        onHide={() => setShowModal(false)}
        size='lg'
        className='summary-modal'
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className='heading'>
            <TbBulb />{' '}
            <span style={{ height: 'fit-content', flex: 1 }}>
              {Capitalize(activesummary.level || '') + ' Performance'}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='d-flex popup'>
            <div>{parse(activesummary.summary.replace(/\n/g, '<br/>'))}</div>
          </div>
        </Modal.Body>
      </Modal>
    );
  };

  return (
    <div className='narratives mb-3 place-container'>
      <h5 className='mb-4 title'>
        <BsChatSquareDots />
        Business Narrative
      </h5>
      <div className='row m-0'>
        {!loader &&
          dimsummary.length > 0 &&
          dimsummary.map((x) => {
            const cardlength = 6;
            const text_length = 380;
            const text = x.summary.length > text_length ? true : false;
            const title = Capitalize(x.level) + ' Performance';
            const content = text
              ? x.summary.substring(0, text_length - 1)
              : x.summary;
            const index = (x.date + x.level)
              .replace(' | ', '')
              .replace(' ', '')
              .replace(',', '');
            return (
              <div
                className={`col-xs-12 col-md-${cardlength} col-lg-${cardlength} mb-3`}
                key={index}
              >
                <div className='x-card'>
                  <div className='narrative-heading'>
                    <TbBulb />{' '}
                    <span style={{ height: 'fit-content', flex: 1 }}>
                      {title}
                    </span>
                  </div>
                  <div className='summary-content'>
                    {parse(content.replace(/\n/g, '<br/>'))}
                    {text && '...'}{' '}
                    {text && (
                      <span
                        className='see-more'
                        onClick={() => {
                          setActiveSummary(x);
                          setShowModal(true);
                        }}
                      >
                        See more <HiOutlineArrowNarrowRight />
                      </span>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        {!loader && dimsummary.length === 0 && (
          <div className='no-data'>No Narratives found</div>
        )}
        {!loader && narrativeModal()}
        {loader && (
          <div className='loader'>
            <Triangle
              height='80'
              width='80'
              ariaLabel='triangle-loading'
              wrapperStyle={{}}
              wrapperClassName=''
              visible={true}
            />
            <span>{loadermessage}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(BusinessNarratives);
